import { ChevronRightOutlined, HomeOutlined } from "@mui/icons-material";
import { Breadcrumbs, Container, Link, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { Link as RouterLink } from "react-router-dom";

export const AdvisoryManagementLayout = ({ children }: PropsWithChildren) => {
	return (
		<Stack maxWidth={1140} mx="auto">
			<Container maxWidth={false}>
				<Breadcrumbs separator={<ChevronRightOutlined color="disabled" />}>
					<Link to="/" component={RouterLink} sx={{ display: "flex" }}>
						<HomeOutlined color="disabled" fontSize="medium" />
					</Link>
					<Typography color="primary.main" fontWeight={600}>
						Správce obchodů
					</Typography>
				</Breadcrumbs>
			</Container>
			<Container maxWidth={false} sx={{ pt: 1.5 }}>
				<Stack sx={{ flexDirection: "column", gap: 3 }}>{children}</Stack>
			</Container>
		</Stack>
	);
};
